module.exports = __webpack_public_path__ + "static/media/securityDeposit.bdf4963c.svg";